(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/dialog-wager-content/assets/javascripts/helpers/handlebarhelper.js') >= 0) return;  svs.modules.push('/components/racing/dialog-wager-content/assets/javascripts/helpers/handlebarhelper.js');
"use strict";


(function () {
  'use strict';

  function registerHelpers(hbs) {
    hbs.registerHelper('getHeadLine', index => "".concat(index + 1, ":A"));
  }
  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }
})();

 })(window);